import React from "react";
import { Pie } from "@ant-design/plots";
import constants from './Constants'
const {SecColors}=constants
function PieChart({ data }) {
	data = Object.keys(data).map(item => {
		return { type: item, value: data[item] };
	}).sort(({type:atype},{type:btype})=>{
		if(atype<btype) return -1
		else if( atype>btype) return 1
		else return 0
	});

	const config = {
		data: data,
		angleField: "value",
		colorField: "type",
		radius: 0.45,
		autoFit: true,
		color: (data) => {
			const { type }=data
		return SecColors[type]
		},
	
		tooltip:false,
		label: {
			// type: "outer",
			type: "spider",
			labelHeight: 28,
			offset: "+10%",
			content: ({ percent }) => `${(percent * 100).toFixed(2)}%`,
			style: {
				// fontSize: 15,
				textAlign: "center",
				fill: "#000000"
			}
		},
		legend: {
			layout: "vertical",
			position: "right"
		},
		interactions: [
			{
				type: "element-active"
			}
		]
	};
	return (
		<div
			style={{
				height: "300px"
			}}
		>
			<Pie {...config} />
		</div>
	);
}

export default PieChart;
